import { render, staticRenderFns } from "./DataDownloadPage.vue?vue&type=template&id=1d2995b4&"
import script from "./DataDownloadPage.vue?vue&type=script&lang=js&"
export * from "./DataDownloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports